module.exports = __webpack_public_path__ + "media/Audio19_e.f9f4861a.wav";